<template>
  <div v-if="isVisible" class="custom-modal-overlay" id="review_payment">
    <transition name="scale-fade" mode="out-in" appear>
      <div class="custom-modal" @click.stop>
      <div class="custom-modal-body">
        <div class="text-dark font-weight-bold p-1 p-md-4 d-flex flex-column" style="background-color: white">
          <div v-if="data.fields" class="py-3 mb-4" style="background-color: #84A6D5">
            <div class="text-center">اطلاعات وارد شده</div>
          </div>

          <div v-if="data.fields">
            <div class="d-flex flex-column align-items-center border-bottom w-100 text-nowrap mx-auto my-2 px-4" v-for="field in data.fields">
              <label class="w-100 p-2 text-center" style="background-color: #86999e">{{ field.fa_name }}</label>
              <p class="mx-2 text-right text-wrap">{{ field.value }}</p>
            </div>
          </div>

          <div class="py-3 my-4" style="background-color: #84A6D5">
            <div class="text-center">آیتم ها</div>
          </div>

          <table class="table w-100 text-dark font-weight-bold mx-auto">
            <thead class="text-center">
            <tr>
              <th>آیتم</th>
              <th>تعداد</th>
              <th>قیمت محصول</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(item, idx) in data.items"
                :key="(item, idx)"
            >
              <td class="text-dark">{{ item.title }}</td>
              <td class="text-dark">{{ item.number }}</td>
              <td class="text-dark">{{ item.final_amount.toLocaleString() + " ریال" }}</td>
            </tr>
            </tbody>
          </table>
          <hr class="w-100 bg-secondary">

          <div class="my-2 mx-auto w-75">
            <div v-if="data.wage" class="d-flex align-items-start justify-content-between">
              <h5>کارمزد درگاه</h5>
              <p class="text-primary font-weight-bold">
                {{ data.wage.toLocaleString() + " ریال" }}
              </p>
            </div>
            <div class="d-flex align-items-start justify-content-between">
              <h5>مبلغ قابل پرداخت</h5>
              <p class="text-primary font-weight-bold">
                {{ (data.payment_amount + data.wage).toLocaleString() + " ریال" }}
              </p>
            </div>
          </div>

          <div class="w-75 my-3 mt-4 mx-auto d-flex justify-content-center">
            <button id="payment-btn" class="btn btn-primary" @click="payment" style="width: 100px">ادامه</button>
            <button class="btn btn-danger mx-2 text-nowrap" @click="closeModal" style="width: 100px">اصلاح اطلاعات</button>
          </div>
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ReviewPayment',
  props: {
    data: {
      required: true,
    },
    isVisible: {
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    payment() {
      this.$emit('payment')
    }
  }
};
</script>

<style scoped>
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.custom-modal {
  background-color: white;
  border-radius: 30px;
  width: 80%;
  max-width: 500px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.custom-modal-body {
  overflow-y: auto; /* Makes the body scrollable */
  max-height: calc(90vh - 40px); /* Adjust based on padding */
  padding: 10px;
  border-radius: 10px; /* This ensures the scrollbar doesn't go outside the rounded corners */
}

/* Customize scrollbar */
.custom-modal-body::-webkit-scrollbar {
  width: 6px; /* Adjust width of the scrollbar */
}

.custom-modal-body::-webkit-scrollbar-thumb {
  background-color: #aaa; /* Color of the scrollbar thumb */
  border-radius: 10px; /* Makes the thumb rounded */
}

.custom-modal-body::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background color of the scrollbar track */
  border-radius: 10px;
}


/* Modal scale + fade animation */
.scale-fade-enter-active,
.scale-fade-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.scale-fade-enter {
  opacity: 0;
  transform: scale(0.2);
}

.scale-fade-leave-to {
  opacity: 0;
  transform: scale(0.2);
}
</style>